import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Compact EN | 中文 toggle. Persists choice to localStorage via i18next-browser-languagedetector.
 * Stays visually identical regardless of which language is active.
 */
export default function LanguageToggle({ style = {} }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('zh') ? 'zh' : 'en';

  function setLang(lang) {
    if (lang === current) return;
    i18n.changeLanguage(lang);
  }

  const baseBtn = {
    fontFamily: 'var(--mono)',
    fontSize: 11,
    fontWeight: 600,
    padding: '4px 10px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all .15s',
    letterSpacing: '.04em',
  };

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      background: 'var(--bg3)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      overflow: 'hidden',
      ...style,
    }}>
      <button
        type="button"
        onClick={() => setLang('en')}
        style={{
          ...baseBtn,
          color: current === 'en' ? 'white' : 'var(--t2)',
          background: current === 'en' ? 'var(--blue)' : 'transparent',
        }}
        aria-pressed={current === 'en'}
      >
        EN
      </button>
      <div style={{ width: 1, height: 14, background: 'var(--border)' }} />
      <button
        type="button"
        onClick={() => setLang('zh')}
        style={{
          ...baseBtn,
          color: current === 'zh' ? 'white' : 'var(--t2)',
          background: current === 'zh' ? 'var(--blue)' : 'transparent',
        }}
        aria-pressed={current === 'zh'}
      >
        中文
      </button>
    </div>
  );
}
